
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MapPin } from 'lucide-react';

interface LocationMapProps {
  mapSrc: string;
  businessName: string;
  directions: string[];
}

const LocationMap: React.FC<LocationMapProps> = ({
  mapSrc,
  businessName,
  directions
}) => {
  return (
    <section className="mb-12">
      <h2 className="text-3xl font-bold mb-6 flex items-center">
        <MapPin className="h-8 w-8 text-primary mr-3" />
        Visit Our {businessName} Location
      </h2>
      <Card>
        <CardContent className="pt-6">
          <div className="grid lg:grid-cols-2 gap-6">
            <div>
              <iframe
                src={mapSrc}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${businessName} Location`}
                className="rounded-lg shadow-lg"
              />
            </div>
            <div className="space-y-4">
              <h3 className="text-xl font-bold">Directions to Our Office:</h3>
              <ul className="space-y-2 text-sm">
                {directions.map((direction, index) => (
                  <li key={index}>• {direction}</li>
                ))}
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default LocationMap;
